import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { useStudentAtdList } from "../../assets/api/UseStudentGetApi";
import TableFilterTemplate from "../../shared/utils/TableFilterTemplate";

const AttendanceTableList = ({ apartmentId, courseId }) => {
    const { data: AttendanceList, isLoading } = useStudentAtdList({ apartment_id: apartmentId, course_id: courseId });
   const studentRows = AttendanceList?.data?.map((item, index) => ({
        attendance_date: item?.attendance_date,
        apartment_name: item?.apartment_name,
        attendance_status: item?.attendance_status,
        ...item,
        id: index + 1,
    }));
    const customerColumns = [
        {
            field: "id",
            headerName: "Sr No",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },

        {
            field: "attendance_date",
            headerName: "Date",
            flex: 1,
            renderCell: (params) => <Typography variant="h6">{params.value}</Typography>,
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="h6">{params.value}</Typography>,
        },
        {
            field: "attendance_status",
            headerName: "Attendance",
            flex: 1,
            renderCell: (params) => <Typography variant="h6" color={params.value === 1 ? "success.main" : "error.main"}>{params.value === 1 ? "Present" : "Absent"}</Typography>,
        },
        {
            field: "remarks",
            headerName: "Remark",
            flex: 1,
            renderCell: (params) => <Typography variant="h6">{params.value}</Typography>,
        },
    ];
    return (
        <Box>

            <TableFilterTemplate
                title="Attendance List"
                columns={customerColumns}
                rowsData={studentRows || []}
                isLoading={isLoading}
            />

        </Box>
    );
};

export default AttendanceTableList;
